<template>
    <div id="compamyLog">
        <p class="log-title">企业日志</p>
        <!-- 列表 -->
        <div class="list-box">
            <div class="bg">
                <div class="search-box">
                    <div>
                        筛选条件
                        <el-select v-model="functionId" placeholder="请选择" class="m-l-5">
                            <el-option :value='null' label="全部模块"></el-option>
                            <el-option :value=1 label="设备管理"></el-option>
                            <el-option :value=2 label="报警管理"></el-option>
                            <el-option :value=3 label="维保计划"></el-option>
                            <el-option :value=4 label="计划任务"></el-option>
                            <el-option :value=5 label="首页编辑"></el-option>
                        </el-select>
                    </div>
                    <div>
                        时间
                        <el-date-picker
                            v-model="beginDate"
                            :editable="false"
                            type="date"
                            class="time m-r-12 m-l-5"
                            placeholder="选择日期"
                            :picker-options="pickerOptionsStart"
                            format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd">
                        </el-date-picker>
                        <span class="m-r-12">至</span>
                        <el-date-picker
                            v-model="endDate"
                            :editable="false"
                            type="date"
                            class="time"
                            placeholder="选择日期"
                            :picker-options="pickerOptionsEnd"
                            format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd">
                        </el-date-picker>
                    </div>
                </div>
                <div class="search-box">
                    <div>
                        用户名<el-input v-model="userName" placeholder="请输入用户名" class="m-l-5 w-200"></el-input>
                    </div>
                    <div>
                        登录ip<el-input v-model="ip" placeholder="请输入ip" class="m-l-5 w-200"></el-input>
                    </div>
                    <div>
                        详情信息关键字<el-input v-model="keyword"  @keyup.enter.native="search" placeholder="请输入详情关键字" class="m-l-5 w-200"></el-input>
                    </div>
                    <el-button type="primary" @click="search">搜索</el-button>
                    <a :href="exportLogUrl" id="exportLog" class="exportLog-btn" @click="exportLog">导出</a>
                </div>
                <div class="company-list clearfix">
                    <ul class="list-title" style="position: relative; top: 25px; width: 97.6%;">
                        <li class="w-18">用户名</li>
                        <li>登录ip</li>
                        <li class="w-18">时间</li>
                        <li>操作模块</li>
                        <li class="w-32">操作详情</li>
                    </ul>
                    <div class="scroll">
                        <ul class="list-details" v-for="(item,i) in dataList" :key="i" v-show="dataList.length!=0">
                            <li :title="item.groupName?item.userName+'/'+item.groupName:item.userName" class="w-18">{{item.userName}} <span v-if="item.groupName">/{{item.groupName}}</span></li>
                            <li :title="item.ip">{{item.ip}}</li>
                            <li :title="changeTime(item.createdTime)" class="w-18">{{changeTime(item.createdTime)}}</li>
                            <li :title="item.functionName">{{item.functionName}}</li>
                            <li :title="item.content" class="w-32">{{item.content}}</li>
                        </ul>
                    </div>
                    <!-- 分页 -->
                    <div style="margin-top: 20px; margin-left: 16px;">
                        <Pagination @setSize="setSize" @setNum="setNum" :totalCount="totalCount" :setNumber="pageNumber"></Pagination>
                    </div>
                </div>
                <!-- 没有列表数据 -->
                <div class="nullDataBox" v-show="dataList.length==0">
                    <img :src="nullData" class="nullData">
                    <span>什么东西都没有找到...</span>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Pagination from "@/components/PublicAssembly/pagination"
export default {
    data() {
        return {
            nullData:require('@/assets/image/index/nullData.png'),
            totalCount:1,
            pageSize:10,
            pageNumber:1,
            dataList:[],
            state:0,
            functionId:"",
            beginDate:"",
            userName:"",
            ip:"",
            endDate:"",
            keyword:"",
            pickerOptionsStart: {
                disabledDate: time => {
                    if (this.endTime) {
                        return time.getTime() > new Date(this.endTime).getTime()
                    }
                }
            },
            pickerOptionsEnd: {
                disabledDate: time => {
                    if (this.beginDate) {
                        return time.getTime() < new Date(this.beginDate).getTime() - 86400000
                    }
                }
            },
            exportLogUrl:'',
        }
    },
    components:{
        Pagination,
    },
    props: {
        companyId:{
            type:Number,
            required:true,
        }
    },
    created() {
        this.$store.state.headerActive=5;
        this.pageSize=this.$store.state.userConfig.rowsPerPage;
        this.exportLog()
        this.getlist({pageNumber:1,length:Number(this.pageSize),companyId:this.companyId});
    },
    methods: {
        // 获取列表
        getlist(parm){
            this.get('/Log/queryCompanyLog',parm).then((res)=>{
                if(res.success){
                    this.dataList=res.result.data
                    this.totalCount = res.result.totalCount
                }else{
                    this.$compamyLog({
                        compamyLog: `获取列表数据失败：${res.message}`,
                        type: 'warning'
                    });
                }
            })
        },
        // 修改分页size
        setSize(pageObj){
            this.pageSize=pageObj.size;
            let parm={
                pageNumber:this.pageNumber,
                length:this.pageSize,
                userName:this.userName,
                ip:this.ip,
                functionId:this.functionId,
                beginDate:this.beginDate==''||this.beginDate==null?null:new Date(this.beginDate+' 00:00:00').getTime().toString(),
                endDate:this.endDate==''||this.endDate==null?null:new Date(this.endDate+' 23:59:59').getTime().toString(),
                keyword:this.keyword,
                companyId:this.companyId
            }
            this.getlist(parm)
        },
        // 修改页数
        setNum(number){
            this.pageNumber=number;
            let parm={
                pageNumber:this.pageNumber,
                length:this.pageSize,
                userName:this.userName,
                ip:this.ip,
                functionId:this.functionId,
                beginDate:this.beginDate==''||this.beginDate==null?null:new Date(this.beginDate+' 00:00:00').getTime().toString(),
                endDate:this.endDate==''||this.endDate==null?null:new Date(this.endDate+' 23:59:59').getTime().toString(),
                keyword:this.keyword,
                companyId:this.companyId
            }
            this.getlist(parm)
        },
        // 搜索
        search(){
            let parm={
                pageNumber:this.pageNumber,
                length:this.pageSize,
                userName:this.userName,
                ip:this.ip,
                functionId:this.functionId,
                beginDate:this.beginDate==''||this.beginDate==null?null:new Date(this.beginDate+' 00:00:00').getTime().toString(),
                endDate:this.endDate==''||this.endDate==null?null:new Date(this.endDate+' 23:59:59').getTime().toString(),
                keyword:this.keyword,
                companyId:this.companyId
            }
            this.getlist(parm)
        },
        exportLog(){
            let beginDate=this.beginDate==''||this.beginDate==null?"":new Date(this.beginDate+' 00:00:00').getTime().toString()
            let endDate=this.endDate==''||this.endDate==null?"":new Date(this.endDate+' 23:59:59').getTime().toString()
            let url = window.location.protocol + '//' + window.location.host
            // let url = 'http://192.168.3.12'
            url += `/api/v1/Log/exportCompanyLog?companyId=${this.companyId}&pageNumber=${this.pageNumber}&length=${this.pageSize}&keyword=${this.keyword}&userName=${this.userName}&ip=${this.ip}&functionId=${this.functionId}&beginDate=${beginDate}&endDate=${endDate}&requestId=0`
            // console.log(url)
            this.exportLogUrl = url
        }
    },
}
</script>
<style scoped>
    .type-box{
        background-color: #fff;
        width: 216px;
        position: absolute;
        top: 32px;
        left:16px;
        bottom: 0;
        padding: 0 12px;
        box-sizing: border-box;
    }
    .type-box p{
        line-height: 48px;
        font-size: 14px;
        border-bottom: 1px solid #e5e5e5;
    }
    .tabs-box{
        float: left;
        height: 40px;
        overflow: hidden;
        background-color: #fff;
        border-top-left-radius: 5px;
        border-top-right-radius: 5px;
        border: 1px solid #d2d2d2;
    }
    .tabs-box div{
        float: left;
        padding: 9px 0;
    }
    .tabs-box span{
        display: inline-block;
        width: 110px;
        font-size: 14px;
        line-height: 22px;
        border-left: 1px solid #e2e2e2;
        cursor:pointer;
        float: left;
    }
    .tabs-box>div:first-child span{
        border: none;
    }
    .list-box{
        position: absolute;
        top: 60px;
        left: 16px;
        right: 16px;
        bottom: 0;
        min-height: 710px;
        min-width: 1350px;
    }
    .list-top{
        margin: 0px 16px 15px 16px;
        padding-top: 24px;
        height: 34px;
    }
    .add-btn{
        float: left;
        line-height: 32px !important;
        padding: 0 15px !important;
    }
    .search{
        float: right;
        width: 388px;
        margin-right: 10px;
    }
    .search-btn{
        float: right;
    }
    .company-list{
        overflow: hidden;
        height: 85%;
    }
    .scroll{
        overflow: auto;
        width: 97.6%;
        height: 80%;
        max-height: 80% !important;
        margin: 0 16px;
        box-sizing: border-box;
        border: 1px solid #f2f2f2;
        border-bottom-left-radius: 5px;
        border-bottom-right-radius: 5px;
        margin-top: 24px;
    }
    /* .scroll>ul:last-child{
        border-bottom: 0;
    } */
    .list-title,.list-details{
        display: flex;
        justify-content: space-around;
        line-height: 44px;
        font-size: 14px;
        color: #636363;
    }
    .list-title{
        background: #eeeeee;
    }
    .list-title li,.list-details li{
        width: 200px;
        margin: 0 20px;
        text-align: left;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
    .list-details{
        border-top:1px solid #f2f2f2;
    }
    .operate span{
        margin: 0 4px;
        color: #5087e4;
    }
    .w-18{
        width: 18% !important;
    }
    .w-32{
        width: 32% !important;
    }
    .list-details:last-child{
        border-bottom:1px solid #f2f2f2;
    }
    .w-90{
        width: 90px !important;
        margin-right: 40px !important;
    }
    .active{
        background: #5087e4;
        color: #fff;
    }
    .active>span{
        border: 0;
    }
    .bg{
		width: 100%;
    height: 100%;
		/* margin-top: 42px; */
    }
    .search-box{
        text-align: left;
        padding: 22px 20px 0 20px;
        font-size: 14px;
    }
    .search-box div{
        display: inline-block;
        margin-right: 16px;
    }
    .w-200{
        width: 200px !important;
    }
    .m-l-5{
        margin-left: 5px !important;
    }
    .m-r-12{
        margin-right: 12px !important;
    }
    .page-box{
        position: absolute;
        z-index: 999;
        bottom: 68px;
        width: 100%;
    }
</style>
<style>
    #compamyLog .search-box .el-input__inner{
        line-height: 34px !important;
        height: 34px !important;
        padding: 0 10px !important;
    }
    #compamyLog .search-box .el-form-item{
        width: 100% !important;
        margin-bottom: 11px !important;
    }
    #compamyLog .search-box .el-button{
        padding: 9px 20px !important;
    }
    #compamyLog .search-box .el-form-item__label{
        padding: 0 !important;
        color: #2f3a4e !important;
        line-height: 14px !important;
        margin-top: 10px;
        margin-bottom: 5px;
    }
    #compamyLog .search-box .el-form-item__content{
        line-height: 34px !important;
    }
    #compamyLog .search-box .el-form-item.m-b-10 {
        margin-bottom: 10px !important;
    }
    #compamyLog .search-box .el-input__icon{
        line-height: 34px !important;
    }
    #compamyLog .search .el-input__inner{
        line-height: 34px !important;
        height: 34px !important;
        padding: 0 10px !important;
    }
    #compamyLog .time .el-input__inner{
        line-height: 34px !important;
        height: 34px !important;
        padding: 0 10px 0 25px!important;
    }
</style>



// WEBPACK FOOTER //
// src/components/CompanyConsole/CompanyLog/CompanyLog.vue